import { Grid, Typography, Box, Backdrop } from '@mui/material';
import React from 'react';
import Carousel from 'react-material-ui-carousel'
import { Paper, Button } from '@mui/material';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import QuiltedImageList from '../shared/ImageList';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import {List} from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import IconButton from '@mui/material/IconButton';
import NearMeIcon from '@mui/icons-material/NearMe';
import CustomButton from '../shared/CustomButton';
import DateRangeIcon from '@mui/icons-material/DateRange';
const ALL_COLORS = [ //increase this to length of 10
  '#b9d3fa', //'#37A2DA',
  '#fabdb9',
  '#b9fabd', //'#37a354',
  '#faf2b9', //'#b55dba',
  '#fab9c4', //'#b5bd48',
  '#c1b9fa',
  '#f6fab9'
]

function ExperiencesNew(){

    const item =[
        {
            id : 1,
            src : require('../images/exp1.png'),
        },
        {
            id : 2,
            src : require('../images/exp2.png'),
        },
        {
            id : 3,
            src : require('../images/exp3.png'),
        },
        {
            id : 4,
            src : require('../images/exp4.png'),
        },
        {
            id : 5,
            src : require('../images/exp5.png'),
        },
        {
            id : 6,
            src : require('../images/exp6.png'),
        }
    ]

    const images = [
        require('../images/intern/googleanalytics.jpeg'),
        require('../images/photo7.jpeg'),
        require('../images/photo5.png'),
        require('../images/photo6.png'),
        require('../images/intern/photo3.png'),
        require('../images/intern/photo1.png'),
        require('../images/intern/photo2.png'),
        
    ]
    const data = [
    "Integrated the website with Microsoft clarity and Google analytics, Redux, and Designed custom alert messages to make website more interactive",
    "Developed staging server for both frontend-backend and Automated the deployment process using GitLab-docker-Aws, which reduced the deployment time by 70 percent",
    "Designed and Developed a profile page by getting info from 5 different APIs and displaying extensive data using graphs and charts. Users can check their Progress and previous results with a button click",
    "Created APIs in Django which handle Image change(S3 bucket), Name change, and obtaining various kinds of data from MongoDB."
    ]


	const Experience = [
    {
			name : "Sprinklr",
			timeframe : "Feb 2024 - Present",
      jobTitle : "Automation Engineer",
			websitelink : 'https://www.sprinklr.com/',
			tasks : [
				`Automated the whole UI frontend part of Workforce Management Module using Java and Selenium`,
` Api testing of the WFM module using Java and Rest APIs/GraphQL APIs and validating the response from the APIs
`,
`Deployed necessary jobs in jenkins for both of the above test cycles and automating the whole testing Sanity Process`
			],
			skills : ['Java', 'Selenium', 'GraphQL']
		},
		{
			name : "Cogoport",
			timeframe : "Aug 2023 - Dec 2023",
      jobTitle : "Software Development Engineer",
			websitelink : 'https://www.cogoport.com/en-IN',
			tasks : [
				`Successfully led a team of 3 developers in the development of
HRMS-Payroll pages, showcasing proficiency in frontend technologies.`,
` Spearheaded the creation of 5 key modules—Payroll along with other 2
members, Attendance-Leave Management, Off-boarding, Onboarding
flows through which a massive cost-cutting of $ 50k/year and can replace
quickchex in the company.
`,
`Single-handedly Pioneered Expense management and Access management
(automating tool access) which are being used by 900 employees.`,
`Developed Pivot table, calendar Graph features connecting 4 databases in
analytics Dashboard - an alternate to Metabase.`,
			],
			skills : ['React Js', 'Next Js', 'CSS']
		},
		{
			name : "Aspiro - Fintech Saas",
			timeframe : "Feb 2022 - Aug 2022",
      jobTitle : "Software Development Engineer Intern",
			websitelink : 'https://letsaspiro.com/',
			tasks : [
    "Integrated the website with Microsoft clarity and Google analytics, Redux, and Designed custom alert messages to make website more interactive",
    "Developed staging server for both frontend-backend and Automated the deployment process using GitLab-docker-Aws, which reduced the deployment time by 70 percent",
    "Designed and Developed a profile page by getting info from 5 different APIs and displaying extensive data using graphs and charts. Users can check their Progress and previous results with a button click",
    "Created APIs in Django which handle Image change(S3 bucket), Name change, and obtaining various kinds of data from MongoDB."
    ],
			skills : ['React Js', 'Django', 'AWS', 'Material UI']
		},

	]

    const item1 = ['Reactjs', 'Django', 'AWS']
    return(            
    <Box sx={{flexGrow:1, backgroundColor : 'transparent'}} id='Experience' className='z-0'>
              <CustomButton>
            <Typography variant='h6' sx={{fontFamily:'Crimson Text, serif'}} >Experience </Typography>
            </CustomButton>
			{
				Experience.map((item, index) => (
					<Box className="bg-gray-700 p-6 rounded-lg w-95 flex flex-col text-white mt-4">
  {/* Left column (timeframe) */}

  <Box className="flex">
    <div className='text-gray-500'>
      <DateRangeIcon/>
    </div>
    <div className='mx-2 text-gray-500'>{item?.timeframe}</div>
  </Box>
  {/* Right column (name, website link, skills, tasks) */}
  <Box className="w-full flex flex-col flex-grow">
    {/* Header section */}
    <Box className="flex items-center">
      <Typography variant="h5">
        <span className="text-[#66FCF1]"> {item?.jobTitle} </span>
         -  {item?.name}</Typography>
      {item?.websitelink && (
        <IconButton href={item.websitelink}>
          <NearMeIcon className="text-blue-500" />
        </IconButton>
      )}

    </Box>

    <div className='flex flex-wrap'>
    <Stack direction="row" className='flex flex-wrap'>
      {item?.skills.map((data1, i) => (
        <Chip
          key={i}
          label={data1}
          className="px-2 py-1 mr-1 mt-1 font-bold"
          style={{ backgroundColor: ALL_COLORS[i % ALL_COLORS.length] }}
        />
      ))}
    </Stack>
    </div>
    {/* Tasks section */}
    <Box>
      <List>
        {item?.tasks.map((data1, i) => (
         <li className='flex flex-row items-center' key={i}>
         <ArrowRightIcon className="text-white" />
         <p className="font-sans text-base my-2">{data1}</p>
     </li>
        ))}
      </List>
    </Box>

  </Box>
</Box>

				) )
			}
            
            </Box>
    )
}

export default ExperiencesNew;